<script setup lang="ts">
import View from '~/pages-components/blog/catgory-list.vue'

definePageMeta({
  middleware: ['blog'],
})
</script>

<template>
  <div>
    <View />
  </div>
</template>
